module.exports = __webpack_public_path__ + "static/media/page-9.d453215d.png";